import './Settings.scss';

import React from 'react';

export const Settings = ({colorsConfig, onColorChange, readOnly}) => {

  const colorLabels = {
    '--allin-light': 'All In',
    '--raise-light': 'Raise',
    '--call-light': 'Call',
    '--fold-light': 'Fold',
    '--oor-light': 'Out of Range',
    '--text-color-light': 'Text Color',
    '--allin-dark': 'All In',
    '--raise-dark': 'Raise',
    '--call-dark': 'Call',
    '--fold-dark': 'Fold',
    '--oor-dark': 'Out of Range',
    '--text-color-dark': 'Text Color',
  };

  return (
    <div className={'chart-settings'}>
      <h3>Color Palette:</h3>
      <div className={"chart-settings-items"}>
        {Object.entries(colorsConfig).map(([colorName, colorValue]) => colorName.includes('oor') ? null : (
          <div key={colorName}
               className={`chart-settings-item ${colorName.includes('light') ? 'light-theme-setting' : 'dark-theme-setting'}`}>
            <label htmlFor={colorName}>{colorLabels[colorName]}: </label>
            <input
              disabled={readOnly}
              id={colorName}
              type="color"
              value={colorValue}
              onChange={(e) => onColorChange(colorName, e.target.value)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};